//@flow
import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  GET_CLIENT_REQUESTING,
  GET_CLIENT_SUCCESS,
  GET_CLIENT_ERROR,
} from "./constants";
import { fetchApi } from "../api";

const endPoints = {
  getClient: "/v1/clients", // :clientId
};

const getClientApi = data => {
  return fetchApi(`${endPoints.getClient}/${data}`, {}, "get");
};

function* getClientFlow(action) {
  try {
    const response = yield call(getClientApi, action.payload);

    yield put({ type: GET_CLIENT_SUCCESS, payload: response });
  } catch (e) {
    console.log(e);
    yield put({ type: GET_CLIENT_ERROR, error: e });
  }
}

function* watcher() {
  yield takeLatest(GET_CLIENT_REQUESTING, getClientFlow);
}

export default watcher;
